import { Stack, Tooltip, Typography } from '@mui/material'
import { ReactNode } from 'react'

interface Props {
  label: string
  value?: string | number
  children?: ReactNode
  nowrap?: boolean
  showElipsis?: boolean
  displayTooltip?: boolean
  dataCy?: string
}
export const Tile = ({
  label,
  value,
  children,
  nowrap,
  showElipsis,
  displayTooltip,
  dataCy,
}: Props) => (
  <Stack>
    <Typography variant='caption' whiteSpace={nowrap ? 'nowrap' : 'normal'}>
      {label}
    </Typography>
    {children ?? (
      <Tooltip title={value ?? ''} disableHoverListener={!displayTooltip} arrow>
        <Typography
          variant='subtitle2'
          whiteSpace={nowrap ? 'nowrap' : 'normal'}
          sx={{
            textOverflow: showElipsis ? 'ellipsis' : 'unset',
            overflow: showElipsis ? 'hidden' : 'unset',
          }}
          data-cy={dataCy}
        >
          {value}
        </Typography>
      </Tooltip>
    )}
  </Stack>
)
